
export interface GetBackupConfigurationScript {
    exec: string;
    arguments: string;
    timeoutInMs: number;
}